/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 10b70efd47036b72e8d1dec5d12405f81f712e3a
 */

export type Provider = typeof Provider[keyof typeof Provider];


export const Provider = {
  elibri: 'elibri',
  novelist: 'novelist',
} as const;
